import { styledComponent } from 'lib/styled_component';
import { Button } from 'aa-react-ui';

const AnchorButton = styledComponent(Button)`
    cursor: pointer;
    border: none;
    &:selection {
        border: none;
    }
    &:hover {
        border: none;
        text-decoration: underline !important;
    }
`;

AnchorButton.defaultProps = {
  color: 'white'
};

export default AnchorButton;
